import { useQuery } from '@apollo/client';
import { FC } from 'react';
import { HealthProfession } from '../../../types/healthProfession';
import { lookupHealthProfessionQuery } from './health-profession-query'
import { ComponentQueryLoader } from '../component-query-loader';
import { HealthProfessionView } from './health-profession-view';

export interface HealthProfessionViewContainerProps {
  healthProfessionCode: string;
  professionsData? : HealthProfession[];
  label?: string;
  title?: string | React.ReactNode;
  layout?: 'vertical';
  extra?: React.ReactNode;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  displayValueOnly: boolean;
}
export const HealthProfessionViewContainer: FC<HealthProfessionViewContainerProps> = (props) => {
  const { data: healthProfessionInfo, loading : healthProfessionLoading, error: healthProfessionError} = useQuery(lookupHealthProfessionQuery, {
    context: { clientName: 'unauthorized' }
  });
  const getProfessionName = (professionCode: string, healthProfessionInfo: any) => {
    const profession = 
    healthProfessionInfo?.healthProfessions?.healthProfessions?.find((item: HealthProfession) => item.professionCode === professionCode);
    return profession ? profession.professionName : null;
  };

  return <ComponentQueryLoader 
  loading={healthProfessionLoading}
  error={healthProfessionError}
  hasData={healthProfessionInfo}
  hasDataComponent={<HealthProfessionView 
    label={props.label}
    title={props.title}
    layout={props.layout}
    extra={props.extra}
    style={props.style}
    labelStyle={props.labelStyle}
    healthProfessionCode={props.healthProfessionCode}
    displayValueOnly={props.displayValueOnly}
    healthProfessionName ={getProfessionName(props.healthProfessionCode,healthProfessionInfo)}/>}
    />;
  };
  